import type { Config } from 'tailwindcss';
import { sharedTokens } from './tokens';

const { typography, shadow, layout } = sharedTokens;

export const tailwindColors = {
  border: 'hsl(var(--border))',
  input: 'hsl(var(--input))',
  ring: 'hsl(var(--ring))',
  background: 'hsl(var(--background))',
  foreground: 'hsl(var(--foreground))',
  primary: {
    DEFAULT: 'hsl(var(--primary))',
    foreground: 'hsl(var(--primary-foreground))',
  },
  secondary: {
    DEFAULT: 'hsl(var(--secondary))',
    foreground: 'hsl(var(--secondary-foreground))',
  },
  destructive: {
    DEFAULT: 'hsl(var(--destructive))',
    foreground: 'hsl(var(--destructive-foreground))',
  },
  muted: {
    DEFAULT: 'hsl(var(--muted))',
    foreground: 'hsl(var(--muted-foreground))',
  },
  accent: {
    DEFAULT: 'hsl(var(--accent))',
    foreground: 'hsl(var(--accent-foreground))',
  },
  popover: {
    DEFAULT: 'hsl(var(--popover))',
    foreground: 'hsl(var(--popover-foreground))',
  },
  card: {
    DEFAULT: 'hsl(var(--card))',
    foreground: 'hsl(var(--card-foreground))',
  },
  sidebar: {
    DEFAULT: 'hsl(var(--sidebar))',
    foreground: 'hsl(var(--sidebar-foreground))',
    border: 'hsl(var(--sidebar-border))',
    accent: 'hsl(var(--sidebar-accent))',
  },
  success: 'hsl(var(--success))',
  warning: 'hsl(var(--warning))',
  info: 'hsl(var(--info))',
  'brand-accent': {
    DEFAULT: 'hsl(var(--brand-accent))',
    foreground: 'hsl(var(--brand-accent-foreground))',
  },
} satisfies Config['theme'];

export const tailwindPreset = {
  colors: tailwindColors,
  borderRadius: {
    lg: 'var(--radius)',
    md: 'calc(var(--radius) - 2px)',
    sm: 'calc(var(--radius) - 4px)',
  },
  fontFamily: {
    sans: typography.fontFamily.sans,
  },
  fontSize: {
    xs: [typography.fontSize.xs, { lineHeight: typography.lineHeight.tight }],
    sm: [typography.fontSize.sm, { lineHeight: typography.lineHeight.tight }],
    base: [typography.fontSize.base, { lineHeight: typography.lineHeight.normal }],
    lg: [typography.fontSize.lg, { lineHeight: typography.lineHeight.normal }],
    xl: [typography.fontSize.xl, { lineHeight: typography.lineHeight.normal }],
    '2xl': [typography.fontSize['2xl'], { lineHeight: typography.lineHeight.tight }],
  },
  boxShadow: {
    notion: shadow.notion,
    'notion-lg': shadow.notionLg,
    toast: 'var(--shadow-toast)',
  },
  spacing: {
    sidebar: layout.sidebarWidth,
    'sidebar-collapsed': layout.sidebarCollapsedWidth,
    header: layout.headerHeight,
    'header-mobile': layout.mobileHeaderHeight,
    'content-padding': layout.contentPadding,
    'content-padding-mobile': layout.mobileContentPadding,
  },
  keyframes: {
    'accordion-down': {
      from: { height: '0' },
      to: { height: 'var(--reka-accordion-content-height)' },
    },
    'accordion-up': {
      from: { height: 'var(--reka-accordion-content-height)' },
      to: { height: '0' },
    },
  },
  animation: {
    'accordion-down': 'accordion-down 0.2s ease-out',
    'accordion-up': 'accordion-up 0.2s ease-out',
  },
} satisfies NonNullable<Config['theme']>['extend'];
